import { Card, Col, Container, Row } from "react-bootstrap";
import picture1 from "../../assets/img/ranger/diseno.png";
import picture2 from "../../assets/img/ranger/tecnologia.png";
import picture3 from "../../assets/img/ranger/proteccion.png";
import picture4 from "../../assets/img/ranger/experiencias.png";
import Slider from "react-slick";

const QueOfrece = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const datos = [
    {
      title: "Diseño.",
      picture: picture1,
      desc: "La Nueva Ranger presenta un diseño completamente renovado, destacándose por su apariencia moderna y atractiva, tanto en el interior como en el exterior. ",
    },
    {
      title: "Tecnología Inteligente.",
      picture: picture2,
      desc: "La Nueva Ranger se destaca por su tecnología innovadora, incorporando una pantalla LED multitáctil de 12” con alta definición y un panel de instrumentos LED de 12.4”",
    },
    {
      title: "Sentirse Protegido.",
      picture: picture3,
      desc: "La Nueva Ranger incorpora Ford Co-Pilot 360. Un conjunto de tecnologías de asistencia al conductor que ayudan a mejorar la seguridad en la conducción. Incluye funciones como el control de velocidad crucero adaptativo con Spot& Go, cámara 360°, entre otras. ",
    },
    {
      title: "Mis experiencias Ford.",
      picture: picture4,
      desc: "Nuevas experiencias diseñadas especialmente para vos: Conectividad, comodidad y personalización como nunca antes habías visto. ",
    },
  ];
  return (
    <Container className="pt-5 pb-5">
      <Row>
        <Col>
          <h1 className="titNuevaVersion pt-5 pb-4">Que ofrece la nueva versión</h1>
        </Col>
      </Row>
      <Row className="d-md-flex d-none">
        {datos.map((item) => (
          <Col md={3}>
            {" "}
            <Card
              className="cardDatos"
              style={{
                width: "100%",
                padding: "10px",
                height: "100%",
                boxShadow: "1px 1px 10px 1px #ccc",
                border: "none",
              }}
            >
              <Card.Img variant="top" src={item.picture} />
              <Card.Body>
                <Card.Title>{item.title}</Card.Title>
                <Card.Text>{item.desc}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="d-md-none d-block">
        <Col>
          <Slider {...settings}>
            {datos.map((item) => (
              <div className="p-4">
                {" "}
                <Card
                  className="cardDatos"
                  style={{
                    width: "100%",
                    padding: "10px",
                    height: "500px",
                    boxShadow: "1px 1px 10px 1px #ccc",
                    border: "none",
                  }}
                >
                  <Card.Img variant="top" src={item.picture} />
                  <Card.Body>
                    <Card.Title>{item.title}</Card.Title>
                    <Card.Text>{item.desc}</Card.Text>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </Slider>
        </Col>
      </Row>
    </Container>
  );
};

export default QueOfrece;
